<template>
    <FormItem>
        <template #question>Payment Details</template>
        <template #action>
            <v-row no-gutters class="gap-2">
                <div v-if="value">
                    <v-btn
                        x-small
                        outlined
                        class="soli-round"
                        color="accent"
                        @click="showPaymentElement = true"
                        >New Payment Method</v-btn
                    >
                </div>
            </v-row>
        </template>
        <template #response>
            <ShoppingCartPromo
                ref="promo"
                :errors="errors"
                :prices="
                    items.map((e) => {
                        return { id: e.price_id, quantity: e.quantity };
                    })
                "
                :guest="guest"
                :user="user"
                @applyPromo="applyPromo($event)"
                @applyGift="applyGift($event)"
            />

            <UserPaymentMethods
                v-if="user?.pm_last_four"
                :user="user"
                :key="user?.pm_last_four"
                @input="setPaymentMethod($event)"
                @stripeLoaded="$emit('stripeLoaded')"
            />

            <SoliResponsiveDialog
                v-if="showPaymentElement"
                title="New Payment Method"
                @reset="closeModal(() => (showPaymentElement = false))"
                ref="addPaymentMethod"
                :mobileScroll="false"
            >
                <template #body>
                    <v-container>
                        <v-form @submit.prevent="storePaymentMethod(true)">
                            <StripePaymentElement
                                ref="stripeElement"
                                :errors="errors"
                                @stripeLoaded="$emit('stripeLoaded')"
                            />
                            <FormSubmit
                                text="Add Payment Method"
                                gradient="gradient-orange"
                                type="submit"
                                :loading="loading"
                                :errors="errors"
                                valid
                                :large="false"
                                contained
                                icon=""
                            />
                        </v-form>
                    </v-container>
                </template>
            </SoliResponsiveDialog>

            <!--<SoliBtn
                v-if="!value && !$refs.defaultMethod?.loading"
                text="New Payment Method"
                block
                large
                @click="showPaymentElement = true"
            />-->

            <StripePaymentElement
                v-if="!user?.pm_last_four"
                ref="stripeElement"
                :errors="errors"
                @stripeLoaded="$emit('stripeLoaded')"
            />
            <!--<FormSubmit
                text="Add Payment Method"
                gradient="gradient-orange"
                type="submit"
                dark
                :loading="loading"
                :errors="errors"
                valid
                icon=""
                @click="submitManualPaymentMethod"
            />-->
            <slot name="validate"></slot>

            <!--<v-card-text class="my-4">
                    {{
                        totalAmountDue
                            ? `Your payment method will be charged ${formatUnitAmount(
                                  totalAmountDue
                              )}`
                            : "Your card will not be charged"
                    }}. A confirmation will be sent to <a>{{ user.email }}</a
                    >.
                </v-card-text>-->
        </template>
    </FormItem>
</template>

<script>
import ShoppingCartPromo from "../../Components/ShoppingCart/ShoppingCartPromo.vue";
import StripePaymentElement from "../StripePaymentElement.vue";
import FormItem from "../../Components/Form/FormItem.vue";
import FormSubmit from "../../Components/Form/FormSubmit.vue";
import UserPaymentMethods from "../../Components/Users/UserPaymentMethods.vue";
import SoliResponsiveDialog from "../Base/SoliResponsiveDialog.vue";

export default {
    components: {
        ShoppingCartPromo,
        StripePaymentElement,
        FormItem,
        FormSubmit,
        UserPaymentMethods,
        SoliResponsiveDialog,
    },
    props: {
        errors: {
            type: Object,
            default: () => {},
        },
        user: {
            type: Object,
            default: () => {},
        },
        guest: {
            type: Object,
            default: () => {},
        },
        items: {
            type: Array,
            default: () => [],
        },
        subtotal: {
            type: Number,
            default: null,
        },
    },
    data() {
        return {
            loading: false,
            showPaymentElement: false,
            value: null,
        };
    },
    methods: {
        applyPromo(promo) {
            this.$emit("applyPromo", promo);
        },
        applyGift(gift) {
            this.$emit("applyGift", gift);
        },
        setPaymentMethod(paymentMethod) {
            this.value = paymentMethod;
            this.$emit("input", paymentMethod);
        },
        async storePaymentMethod(attachToClient = false) {
            this.loading = true;
            const paymentElement = this.$refs.stripeElement;
            const elements = paymentElement.stripeElements;
            await paymentElement.stripe
                .confirmSetup({
                    elements,
                    confirmParams: {
                        return_url: route("checkout.show", {
                            hashId: this.guest?.id,
                        }),
                    },
                    redirect: "if_required",
                })
                .then((resp) => {
                    if (resp.error) {
                        this.loading = false;
                    } else {
                        this.setPaymentMethod({
                            id: resp.setupIntent.payment_method,
                        });

                        if (attachToClient) {
                            this.attachToClient();
                            return;
                        }

                        this.loading = false;
                    }
                });
        },
        attachToClient() {
            this.$inertia.put(
                route("user.updateDefault", this.user.id),
                { paymentMethod: this.value.id },
                {
                    preserveState: true,
                    preserveScroll: true,
                    onSuccess: () => {
                        this.$refs.addPaymentMethod.show = false;
                        this.loading = false;
                    },
                    onError: (errors) => {
                        this.loading = false;
                        console.log(errors);
                    },
                }
            );
        },
    },
    mounted() {
        console.log(
            route("checkout.show", {
                hashId: this.guest?.id,
            })
        );
    },
};
</script>

<style>
.short-bone {
    transform: translateY(-6px);
}
</style>
